import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Download, MoreHorizontal } from 'react-feather'; // FIXED ICON IMPORT
import './Accounts.css';

const custom_style = `
    .doawnload_btn_new_renew{
        padding: 0px 8px;
        text-align: left;
        width:auto;
        background-color: #FFF;
        // border: 0.5px solid #CED7F3;
        // border-radius: 6px;
        border: none;
        color: #515457;
        font-size: 11.5px;
        font-weight: 500;
        line-height: 14.38px;
        min-height: 100%;

    }
    .download_span_renew{
      color: #1E293B;
      font-weight: 500;
      font-size: 12px;
      line-height: 15px;
      letter-spacing: 0%;
    }
    .download_arrow_renew{
      width:14px;
      margin-right:5px;
    }
    .dropdown-divider {
        height: 1px;
        background: #e0e0e0;
        margin: 4px 0;
    }
`;

const DownloadButtons = ({ account, handleAccountPlanDownload, handleDownloadNotes }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const triggerRef = useRef(null);
  const dropdownRef = useRef(null);
  const [dropdownStyle, setDropdownStyle] = useState({});

  useEffect(() => {
    if (showDropdown && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setDropdownStyle({
        position: 'absolute',
        top: `${rect.bottom + window.scrollY + 10}px`,
        left: `${rect.left + window.scrollX - 80}px`,
        background: '#fff',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        borderRadius: '6px',
        zIndex: 1000,
        padding: '10px',
      });
    }
  }, [showDropdown]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target) &&
        !triggerRef.current.contains(e.target)
      ) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      <button
        className="doawnload_btn ml-2"
        onClick={() =>
          handleAccountPlanDownload(account?.company_code, account?.client_code)
        }
      >
        <Download className="download_arrow" />
        <span className="download_span">Account Plan</span>
      </button>

      <button
        className="doawnload_btn ml-2"
        onClick={() =>
          handleDownloadNotes("delivery_excellence", account?.client_name, account?.name)
        }
      >
        <Download className="download_arrow" />
        <span className="download_span">Delivery Excellence</span>
      </button>

      <button
        className="doawnload_btn ml-2"
        ref={triggerRef}
        onClick={() => setShowDropdown((prev) => !prev)}
        // onMouseEnter={() => setShowDropdown(true)}
        // onMouseLeave={() => setTimeout(() => setShowDropdown(false), 300)}
      >
        <Download className="download_arrow" />
        {/* <MoreHorizontal className="download_arrow" /> */}
        <span className="download_span">+2</span>
      </button>

      {showDropdown &&
        ReactDOM.createPortal(
          <div
            ref={dropdownRef}
            style={dropdownStyle}
            onMouseEnter={() => setShowDropdown(true)}
            onMouseLeave={() => setShowDropdown(false)}
          >
            <style>{custom_style}</style>
            <button
              className="doawnload_btn_new_renew"
              onClick={() =>
                handleDownloadNotes("renewal_note", account?.client_name, account?.name)
              }
            >
              <Download className="download_arrow_renew" />
              <span className="download_span_renew">Renewal Note</span>
            </button>

            <div className="dropdown-divider" />

            <button
              className="doawnload_btn_new_renew"
              onClick={() =>
                handleDownloadNotes("ppm", account?.client_name, account?.name)
              }
            >
              <Download className="download_arrow_renew" />
              <span className="download_span">PPM</span>
            </button>
          </div>,
          document.body
        )}
    </>
  );
};

export default DownloadButtons;
